var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "l-map",
        {
          ref: "map",
          style: _vm.mapStyling,
          attrs: {
            zoom: 10,
            minZoom: 4,
            maxZoom: 18,
            maxBounds: [
              [-90, -180],
              [90, 180],
            ],
            center: _vm.center,
            options: _vm.mapOptions,
          },
          on: {
            "update:zoom": _vm.zoomUpdated,
            "update:bounds": _vm.boundsUpdated,
          },
        },
        [
          _c("l-control", { attrs: { position: "topright", id: "v-step-0" } }, [
            _c(
              "button",
              {
                class: _vm.refreshLoading
                  ? "button is-small is-loading is-success is-outlined is-rounded is-inverted"
                  : "button is-small is-success is-outlined is-rounded is-inverted is-hovered",
                attrs: { "data-tooltip": "Left tooltip content" },
                on: { click: _vm.refresh },
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("i", { staticClass: "fas fa-redo has-text-success" }),
                ]),
              ]
            ),
          ]),
          _c("l-control-zoom", {
            staticClass: "leaflet-control-zoom",
            attrs: { position: "topright" },
          }),
          _c("l-tile-layer", { attrs: { url: _vm.urlSmooth } }),
          _c(
            "l-control",
            { attrs: { position: "bottomright" } },
            [
              _vm.mappingLoaded
                ? _c("QueuePopUp", {
                    attrs: {
                      showQueuePopUp: _vm.showQueuePopUp,
                      queue: _vm.queue,
                      currentAction: _vm.currentAction,
                      busy: _vm.busy,
                    },
                    on: {
                      removeActionInQueue: _vm.removeActionInQueue,
                      closeModal: function ($event) {
                        _vm.showQueuePopUp = false
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "is-centered is-mobile is-flex is-flex-direction-row has-text-centered is-justify-content-center py-3",
          staticStyle: {
            position: "fixed",
            bottom: "0",
            "z-index": "1000",
            left: "0",
            right: "0",
            "background-color": "rgba(255, 255, 255, 0.8)",
          },
        },
        [
          _c("div", { staticClass: "select is-small is-success mx-2" }, [
            _c(
              "select",
              {
                staticStyle: { width: "220px" },
                attrs: { id: "v-step-1", disabled: _vm.retrievingFSA },
                on: { change: _vm.selectRegion },
              },
              [
                _c(
                  "option",
                  { attrs: { value: "ALL REGIONS", selected: "" } },
                  [_vm._v("All Regions")]
                ),
                _vm._l(_vm.regions, function (option) {
                  return _c(
                    "option",
                    { key: option.id, domProps: { value: option.id } },
                    [_vm._v(" " + _vm._s(option.name) + " ")]
                  )
                }),
              ],
              2
            ),
          ]),
          _c("div", { staticClass: "select is-small is-success mx-2" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedShapeType,
                    expression: "selectedShapeType",
                  },
                ],
                staticStyle: { width: "150px" },
                attrs: {
                  disabled:
                    _vm.retrievingFSA ||
                    _vm.$store.state.region === "ALL REGIONS",
                  title:
                    _vm.$store.state.region === "ALL REGIONS"
                      ? "Select a specific region to filter shapes by type"
                      : "Filter shapes by type (geofence, distance, billable, payable)",
                },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.selectedShapeType = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              [
                _c("option", { attrs: { value: "ALL_TYPES" } }, [
                  _vm._v("All Shape Types"),
                ]),
                _c("option", { attrs: { value: "geofence" } }, [
                  _vm._v("Geofence"),
                ]),
                _c("option", { attrs: { value: "distance" } }, [
                  _vm._v("Distance"),
                ]),
                _c("option", { attrs: { value: "billable" } }, [
                  _vm._v("Billable"),
                ]),
                _c("option", { attrs: { value: "payable" } }, [
                  _vm._v("Payable"),
                ]),
              ]
            ),
          ]),
          _vm.selectedShapeType === "billable" ||
          _vm.selectedShapeType === "payable"
            ? _c("div", { staticClass: "mx-2" }, [
                _c(
                  "button",
                  {
                    staticClass: "custom-filter-button",
                    attrs: {
                      disabled:
                        _vm.retrievingFSA ||
                        _vm.$store.state.region === "ALL REGIONS",
                      title:
                        _vm.selectedShapeType === "billable"
                          ? "Select clients to filter"
                          : "Select contractors to filter",
                    },
                    on: { click: _vm.openClientSelectorModal },
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.selectedShapeType === "billable"
                            ? "Select Clients"
                            : "Select Contractors"
                        )
                      ),
                    ]),
                    _vm.selectedClients.length > 0
                      ? _c(
                          "span",
                          { staticClass: "tag is-small is-success ml-2" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.selectedClients.length) + " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ])
            : _vm._e(),
          _vm.selectableFSAMode &&
          _vm.selectedFSAToAdd.length > 0 &&
          !_vm.editSelectableFSAMode
            ? _c(
                "button",
                {
                  staticClass: "button is-small is-success mx-2 is-outlined",
                  on: { click: _vm.openAddFSAShapeZoneModal },
                },
                [_vm._v(" Confirm FSA Zones ")]
              )
            : _vm._e(),
          _vm.selectableFSAMode &&
          _vm.selectedFSAToAdd.length > 0 &&
          _vm.editSelectableFSAMode
            ? _c(
                "button",
                {
                  staticClass: "button is-small is-success mx-2 is-outlined",
                  on: { click: _vm.openEditFSAShapeZoneModal },
                },
                [_vm._v(" Save FSA Zones ")]
              )
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "is-small is-success button mx-2",
              attrs: {
                role: "navigation",
                "aria-label": "dropdown navigation",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "navbar-item has-dropdown-up is-hoverable is-small",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "is-small is-success button",
                      attrs: { id: "v-step-3" },
                    },
                    [_vm._v("Menu")]
                  ),
                  _c("div", { staticClass: "navbar-dropdown" }, [
                    !_vm.retrievingFSA
                      ? _c(
                          "a",
                          {
                            staticClass: "navbar-item",
                            on: {
                              click: function ($event) {
                                _vm.showExportModal = true
                              },
                            },
                          },
                          [_vm._v(" Export Data ")]
                        )
                      : _vm._e(),
                    !_vm.retrievingFSA && _vm.client === "miele"
                      ? _c(
                          "a",
                          {
                            staticClass: "navbar-item",
                            on: {
                              click: function ($event) {
                                _vm.showExportServiceModal = true
                              },
                            },
                          },
                          [_vm._v(" Export For Service ")]
                        )
                      : _vm._e(),
                    _vm.client === "miele" && !_vm.retrievingFSA
                      ? _c(
                          "a",
                          {
                            staticClass: "navbar-item",
                            on: {
                              click: function ($event) {
                                _vm.showExportServiceModal = true
                              },
                            },
                          },
                          [_vm._v(" Export For Miele Professionals ")]
                        )
                      : _vm._e(),
                    _c(
                      "a",
                      {
                        staticClass: "navbar-item",
                        on: {
                          click: function ($event) {
                            _vm.showImportModal = true
                          },
                        },
                      },
                      [_vm._v(" Import Data ")]
                    ),
                    _c("hr", { staticClass: "navbar-divider" }),
                    !_vm.selectableFSAMode &&
                    !_vm.editSelectableFSAMode &&
                    !_vm.FSAConfirmMode
                      ? _c(
                          "a",
                          {
                            staticClass: "navbar-item",
                            on: {
                              click: function ($event) {
                                _vm.showSharedViews = true
                              },
                            },
                          },
                          [_vm._v(" Shared Views ")]
                        )
                      : _vm._e(),
                    !_vm.selectableFSAMode &&
                    !_vm.editSelectableFSAMode &&
                    !_vm.FSAConfirmMode
                      ? _c(
                          "a",
                          {
                            staticClass: "navbar-item",
                            on: {
                              click: function ($event) {
                                _vm.showRegionList = true
                              },
                            },
                          },
                          [_vm._v(" Regions ")]
                        )
                      : _vm._e(),
                    !_vm.selectableFSAMode &&
                    !_vm.editSelectableFSAMode &&
                    !_vm.FSAConfirmMode
                      ? _c(
                          "a",
                          {
                            staticClass: "navbar-item",
                            on: {
                              click: function ($event) {
                                _vm.showZoneListModal = true
                              },
                            },
                          },
                          [_vm._v(" Manage Zones ")]
                        )
                      : _vm._e(),
                    _c(
                      "a",
                      {
                        staticClass: "navbar-item",
                        on: {
                          click: function ($event) {
                            _vm.showRouteHubModal = !_vm.showRouteHubModal
                          },
                        },
                      },
                      [_vm._v(" Manage Lanes ")]
                    ),
                    !_vm.selectableFSAMode &&
                    !_vm.editSelectableFSAMode &&
                    !_vm.FSAConfirmMode
                      ? _c(
                          "a",
                          {
                            staticClass: "navbar-item",
                            on: {
                              click: function ($event) {
                                _vm.showHubModal = true
                              },
                            },
                          },
                          [_vm._v(" Manage Reference Points ")]
                        )
                      : _vm._e(),
                    _c("hr", { staticClass: "navbar-divider" }),
                    !_vm.addMoreShapeMode &&
                    !_vm.deletePartShapeMode &&
                    !_vm.FSAConfirmMode
                      ? _c(
                          "a",
                          {
                            staticClass: "navbar-item",
                            on: {
                              click: function ($event) {
                                _vm.selectableFSAMode
                                  ? _vm.closeSelectableFSAMode(false)
                                  : _vm.selectableFSAModeOn(false)
                              },
                            },
                          },
                          [_vm._v(" Toggle FSAs visibility ")]
                        )
                      : _vm._e(),
                    _c(
                      "a",
                      {
                        staticClass: "navbar-item",
                        on: {
                          click: function ($event) {
                            _vm.showFSASelector = true
                          },
                        },
                      },
                      [_vm._v(" Switch FSA Province ")]
                    ),
                    _c("hr", { staticClass: "navbar-divider" }),
                    _c(
                      "a",
                      {
                        staticClass: "navbar-item",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("/home")
                          },
                        },
                      },
                      [_vm._v(" Toggle Environment ")]
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ]
      ),
      _c("notifications", { attrs: { group: "fsa", position: "bottom left" } }),
      _c("notifications", {
        staticClass: "export_notification",
        attrs: { group: "export", position: "top left" },
      }),
      _c("notifications", {
        attrs: { group: "zones", position: "bottom right" },
      }),
      _c("notifications", {
        attrs: { group: "lanes", position: "bottom center" },
      }),
      _c("notifications", {
        staticClass: "postal-code-search",
        attrs: { group: "postal_code_search", position: "top right" },
      }),
      _vm.mappingLoaded && _vm.showZoneListModal
        ? _c("ZoneList", {
            attrs: { showZoneListModal: _vm.showZoneListModal },
            on: {
              renderMap: function ($event) {
                return _vm.renderZonesToMap(false, _vm.$store.state.region)
              },
              closeModal: function ($event) {
                _vm.showZoneListModal = false
              },
            },
          })
        : _vm._e(),
      _vm.mappingLoaded && _vm.showSharedViews
        ? _c("SharedViews", {
            attrs: {
              showSharedViews: _vm.showSharedViews,
              regions: _vm.regions,
            },
            on: {
              closeModal: function ($event) {
                _vm.showSharedViews = false
              },
            },
          })
        : _vm._e(),
      _vm.mappingLoaded && _vm.showRegionList
        ? _c("RegionList", {
            attrs: { showRegionList: _vm.showRegionList },
            on: {
              renderMap: function ($event) {
                return _vm.renderZonesToMap(false, _vm.$store.state.region)
              },
              closeModal: function ($event) {
                _vm.showRegionList = false
              },
            },
          })
        : _vm._e(),
      _vm.mappingLoaded && _vm.showChangingRegionModal
        ? _c("ChangeRegionModal", {
            attrs: { showChangingRegionModal: _vm.showChangingRegionModal },
            on: {
              closeModal: function ($event) {
                _vm.showChangingRegionModal = false
              },
            },
          })
        : _vm._e(),
      _vm.mappingLoaded && _vm.showHistoryModal
        ? _c("History", {
            attrs: { showHistory: _vm.showHistoryModal },
            on: {
              closeModal: function ($event) {
                _vm.showHistoryModal = false
              },
            },
          })
        : _vm._e(),
      _vm.mappingLoaded && _vm.showRouteHubModal
        ? _c("HubRouteTable", {
            attrs: { showRouteHubModal: _vm.showRouteHubModal },
            on: {
              closeModal: function ($event) {
                _vm.showRouteHubModal = false
              },
            },
          })
        : _vm._e(),
      _vm.mappingLoaded && _vm.showFSASelector
        ? _c("FSASelector", {
            attrs: {
              showFSASelector: _vm.showFSASelector,
              retrievingFSA: _vm.retrievingFSA,
            },
            on: {
              closeModal: function ($event) {
                _vm.showFSASelector = false
              },
              selectFSAProvince: _vm.selectFSAProvince,
              closeSelectableFSAMode: _vm.closeSelectableFSAMode,
            },
          })
        : _vm._e(),
      _vm.mappingLoaded && _vm.showExportModal
        ? _c("ExportModal", {
            attrs: { showExportModal: _vm.showExportModal },
            on: {
              closeModal: function ($event) {
                _vm.showExportModal = false
              },
            },
          })
        : _vm._e(),
      _vm.mappingLoaded && _vm.showExportServiceModal
        ? _c("ExportServiceModal", {
            attrs: { showExportServiceModal: _vm.showExportServiceModal },
            on: {
              closeModal: function ($event) {
                _vm.showExportServiceModal = false
              },
            },
          })
        : _vm._e(),
      _vm.mappingLoaded && _vm.showImportModal
        ? _c("ImportModal", {
            attrs: { showImportModal: _vm.showImportModal },
            on: {
              closeModal: function ($event) {
                _vm.showImportModal = false
              },
            },
          })
        : _vm._e(),
      _vm.mappingLoaded && _vm.showLaneWizard
        ? _c("LaneWizard", {
            attrs: {
              show: _vm.showLaneWizard,
              "hub-ids": _vm.laneWizardHubIds,
              "lane-data": _vm.laneWizardData,
              "is-editing": !!_vm.laneWizardData,
            },
            on: {
              close: function ($event) {
                _vm.showLaneWizard = false
              },
              laneSaved: _vm.handleLaneSaved,
            },
          })
        : _vm._e(),
      _vm.mappingLoaded && _vm.showHubModal
        ? _c("HubTable", {
            attrs: { showHubModal: _vm.showHubModal },
            on: {
              closeModal: function ($event) {
                _vm.showHubModal = false
              },
            },
          })
        : _vm._e(),
      _vm.showClientSelectorModal
        ? _c(
            "div",
            {
              staticClass: "modal is-active",
              staticStyle: { "z-index": "999999" },
            },
            [
              _c("div", {
                staticClass: "modal-background",
                on: { click: _vm.closeClientSelectorModal },
              }),
              _c(
                "div",
                {
                  staticClass: "modal-card",
                  staticStyle: { "z-index": "1000000", height: "500px" },
                },
                [
                  _c("header", { staticClass: "modal-card-head" }, [
                    _c("p", { staticClass: "modal-card-title" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.selectedShapeType === "billable"
                              ? "Select Clients"
                              : "Select Contractors"
                          ) +
                          " "
                      ),
                    ]),
                    _c("button", {
                      staticClass: "delete",
                      attrs: { "aria-label": "close" },
                      on: { click: _vm.closeClientSelectorModal },
                    }),
                  ]),
                  _c("section", { staticClass: "modal-card-body" }, [
                    _c("div", { staticClass: "content" }, [
                      _c("p", { staticClass: "mb-4" }, [
                        _vm._v(
                          " Select " +
                            _vm._s(
                              _vm.selectedShapeType === "billable"
                                ? "clients"
                                : "contractors"
                            ) +
                            " to filter " +
                            _vm._s(_vm.selectedShapeType) +
                            " shapes. Only shapes that have the selected " +
                            _vm._s(
                              _vm.selectedShapeType === "billable"
                                ? "clients"
                                : "contractors"
                            ) +
                            " will be displayed on the map. "
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "mb-5" },
                        [
                          _c("GlobalSelector", {
                            attrs: {
                              label:
                                _vm.selectedShapeType === "billable"
                                  ? "Clients"
                                  : "Contractors",
                              placeholder:
                                _vm.selectedShapeType === "billable"
                                  ? "Select clients..."
                                  : "Select contractors...",
                              disabled: false,
                              dataSource:
                                _vm.selectedShapeType === "billable"
                                  ? "clients"
                                  : "contractors",
                              type: "multi",
                              showSearch: true,
                            },
                            model: {
                              value: _vm.tempSelectedClients,
                              callback: function ($$v) {
                                _vm.tempSelectedClients = $$v
                              },
                              expression: "tempSelectedClients",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _c("footer", { staticClass: "modal-card-foot" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button is-small is-success",
                        on: { click: _vm.applyClientFilter },
                      },
                      [_vm._v(" Apply Filter ")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "button is-small",
                        on: { click: _vm.closeClientSelectorModal },
                      },
                      [_vm._v(" Cancel ")]
                    ),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }